export const AddOnType = {
    HistoricalData: "HistoricalDataDynamic",
    AdditionalUsers: "AdditionalUsersDynamic",
    AdditionalProjects: "AdditionalProjectsDynamic",
    AdditionalDataCredits: "DataCreditsDynamic",
    SiDataCredits: "SiDataCredits",
    SeoKeywords: "SeoKeywordsDynamic",
    SeoCampaigns: "SeoCampaignsDynamic",
    MonitorAndProtectCrawls: "MonitorAndProtectCrawls",
    CountryFilter: "CountryFilter",
} as const;

export type AddOnType = (typeof AddOnType)[keyof typeof AddOnType];

// TODO: Once all addons have changed their name we should
// only have this and phase out `AddOnType`
export const ADDON_TYPE_NAME_DICT = {
    HistoricalDataDynamic: "HistoricalDataDynamic",
    AdditionalUsersDynamic: "AdditionalUsersDynamic",
    DataCreditsDynamic: "DataCreditsDynamic",
    SiDataCredits1000: "SiDataCredits1000",
    AdditionalProjectsDynamic: "AdditionalProjectsDynamic",
    SeoCampaignsDynamic: "SeoCampaignsDynamic",
    SeoKeywordsDynamic: "SeoKeywordsDynamic",
    CountryFilterDynamic: "CountryFilterDynamic",
    MonitorAndProtectCrawls: "MonitorAndProtectCrawls",
} as const;

export type AddonTypeName = keyof typeof ADDON_TYPE_NAME_DICT;

export const getAddonTypeFromName = (addonTypeName: AddonTypeName): AddOnType => {
    switch (addonTypeName) {
        case ADDON_TYPE_NAME_DICT.AdditionalProjectsDynamic:
            return AddOnType.AdditionalProjects;
        case ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic:
            return AddOnType.AdditionalUsers;
        case ADDON_TYPE_NAME_DICT.SeoCampaignsDynamic:
            return AddOnType.SeoCampaigns;
        case ADDON_TYPE_NAME_DICT.SeoKeywordsDynamic:
            return AddOnType.SeoKeywords;
        case ADDON_TYPE_NAME_DICT.HistoricalDataDynamic:
            return AddOnType.HistoricalData;
        case ADDON_TYPE_NAME_DICT.DataCreditsDynamic:
            return AddOnType.AdditionalDataCredits;
        case ADDON_TYPE_NAME_DICT.SiDataCredits1000:
            return AddOnType.SiDataCredits;
        case ADDON_TYPE_NAME_DICT.CountryFilterDynamic:
            return AddOnType.CountryFilter;
        case ADDON_TYPE_NAME_DICT.MonitorAndProtectCrawls:
            return AddOnType.MonitorAndProtectCrawls;
    }
};

export const projectHookPreselect = ADDON_TYPE_NAME_DICT.AdditionalProjectsDynamic;
export const userHookPreselect = ADDON_TYPE_NAME_DICT.AdditionalUsersDynamic;
export const campaignHookPreselect = ADDON_TYPE_NAME_DICT.SeoCampaignsDynamic;
export const keywordHookPreselect = ADDON_TYPE_NAME_DICT.SeoKeywordsDynamic;
export const historyHookPreselect = ADDON_TYPE_NAME_DICT.HistoricalDataDynamic;
export const dataCreditsHookPreselect = ADDON_TYPE_NAME_DICT.DataCreditsDynamic;
export const countryHookPreselect = ADDON_TYPE_NAME_DICT.CountryFilterDynamic;
